module.exports = __webpack_public_path__ + "static/media/Invista.60e794a7.svg";